import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractCrudService } from '../../../../shared/components/crud/abstract-crud.service';
import { RELATIVE_URL } from './crud-config';
import { Observable } from 'rxjs';
import { API_PATH } from 'src/environments/environment';
import { tap, catchError, of } from 'rxjs';

@Injectable()
export class GlobalConfigService extends AbstractCrudService {
  constructor(protected override httpClient: HttpClient) {
    super(httpClient, RELATIVE_URL);
  }

  getGlobalConfig(origin?: string): Observable<any> {
    const params: any = {};
    if (origin) params['origin'] = origin;
    return this.httpClient.get(`${API_PATH}${this.relativeUrl}`, { params });
  }

  // Método para buscar a configuração global ativa
  getActiveConfig(): Observable<any> {
    console.log('Chamando API para buscar configuração ativa');
    const url = `${API_PATH}${this.relativeUrl}/active`;

    return this.httpClient.get(url).pipe(
      tap(response => {
        console.log('Resposta da API (active):', response);
      }),
      catchError(error => {
        console.error('Erro ao buscar configuração ativa:', error);
        // Retornar um objeto vazio em caso de erro para não quebrar o fluxo
        return of({});
      })
    );
  }

  // Sobrescrever o método update para usar PATCH com formato correto
  override update(id: any, data: any): Observable<any> {
    console.log('Atualizando configuração com ID:', id);
    console.log('Dados recebidos para atualização:', data);

    // Criar um novo objeto usando apenas os campos necessários
    const processedData = {
      // Enviar como string com formato '0.XX' que é compatível com IsDecimal
      interest: parseFloat(data.interest).toFixed(2),
      fine: parseFloat(data.fine).toFixed(2),
      interestDescription: data.interestDescription || 'Taxa de juros',
      fineDescription: data.fineDescription || 'Multa por atraso'
    };

    console.log('Dados finais a serem enviados:', processedData);
    console.log('Tipos dos dados:', {
      interest: typeof processedData.interest,
      fine: typeof processedData.fine
    });

    const url = `${API_PATH}${this.relativeUrl}/${id}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.httpClient.patch(url, processedData, { headers });
  }
}
